import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import config from '../../../helpers/config';

const useStyles = makeStyles(theme => ({
    
    banner: props => ({

        position: 'relative',
        height: '500px',
        background: 'linear-gradient(45deg, #f7eaf3, #fcfeff)',
        width: '90%',
        borderTopLeftRadius: '250px',
        borderBottomLeftRadius: '250px',
        margin: '100px 0px 100px 10%',

        '& .background': {
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            position: 'absolute',
            backgroundSize: 'contain',
            backgroundPosition: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: props && props.banner ? `url(${config.S3Endpoint}${props.banner.imgUrl})` : '',
            [theme.breakpoints.down("xs")]: { 
                display: 'none'
            },
            [theme.breakpoints.up("xs")]: {  
                display: 'none'
            },
            [theme.breakpoints.up("sm")]: {  
                display: 'none'
            },
            [theme.breakpoints.up("md")]: {   
                display: 'block'
            },
            [theme.breakpoints.up("lg")]: {  
                display: 'block'
            }
        },

        "& .title": {
            width: '50%',
            height: '100%',
            color: '#b8528d',
            textAlign: 'center',
            letterSpacing: '5px',
            transform: 'translateZ(10px)',

            '& h3': {
                lineHeight: '55px',
                textShadow: '1px 1px 4px #ffffff'
            },
            
        
            [theme.breakpoints.down("xs")]: {   
                width: '100%',
            },
            [theme.breakpoints.up("xs")]: {   
                width: '100%', 
            },
            [theme.breakpoints.up("sm")]: {  
                width: '100%',
            },
            [theme.breakpoints.up("md")]: {  
                width: '50%',
            },
            [theme.breakpoints.up("lg")]: {  
                width: '50%',
            },
        },
        
        [theme.breakpoints.down("xs")]: { 
            display: 'none'
        },
        [theme.breakpoints.up("xs")]: {  
            display: 'none'
        },
        [theme.breakpoints.up("sm")]: {  
            display: 'block'
        },
        [theme.breakpoints.up("md")]: {   
            display: 'block'
        },
        [theme.breakpoints.up("lg")]: {  
            display: 'block'
        }

    })

}));


export default (props) => {
    const classes = useStyles(props), 
        {banner} = props;

    return (
        <div className={classes.banner}>
            <div className="background"></div>
            <Grid container alignItems="center" justify="center"  className="title">
                <Grid item xs={12}>
                    {banner.desc.map((d, i) => <Typography key={i} variant="h3">{d}</Typography>)}
                </Grid>
            </Grid>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/tour/MommyBabyBanner.js